import { useTranslation } from 'react-i18next'

import { Checkbox, Box as DarkBox } from '@hivewatch/dark'

import { darkCheckPointsPanelStyles } from './DarkCheckPointsPanel.styles'

interface DarkVerificationPhotoCheckboxIProps {
  colorScheme: 'dark' | 'light'
  isChecked: boolean
  isDisabled: boolean
  onRequiredChange: (required: boolean) => void
}

export const DarkVerificationPhotoCheckbox = ({
  colorScheme,
  isChecked,
  isDisabled,
  onRequiredChange,
}: DarkVerificationPhotoCheckboxIProps) => {
  const { t } = useTranslation()
  const s = darkCheckPointsPanelStyles(colorScheme)

  return (
    <Checkbox
      checked={isChecked}
      colorScheme={colorScheme}
      data-testid='DarkEditCheckPoint:requirePhoto'
      disabled={isDisabled}
      label={
        <DarkBox as='span' {...s.checklistLabel}>
          {t('floors:checkpoint_require_photo')}
        </DarkBox>
      }
      onChange={(e) => onRequiredChange(e.target.checked)}
    />
  )
}
